import { queryRawLocalStorage, removeLocalStorage, setLocalStorage } from '../../../utils/localstorage';
const MINI_TRIAL_GUIDE_STORAGE_KEY = 'hic-mini-trial-guide-open';
const ACTIVE_TRIAL_STORAGE_KEY = 'hic-active-trial-mini-trial-guide';
export const getMiniTrialGuideOpenFromStorage = () => {
  const stored = queryRawLocalStorage(MINI_TRIAL_GUIDE_STORAGE_KEY);
  return stored !== '' && stored !== 'false';
};
export const setMiniTrialGuideState = isOpen => setLocalStorage(MINI_TRIAL_GUIDE_STORAGE_KEY, isOpen);
export const removeMiniTrialGuideStateFromStorage = () => removeLocalStorage(MINI_TRIAL_GUIDE_STORAGE_KEY);
export const getActiveTrial = () => {
  const activeTrial = queryRawLocalStorage(ACTIVE_TRIAL_STORAGE_KEY);
  return activeTrial || '';
};